import { render, staticRenderFns } from "./ExchangeReceivableNoteModel.vue?vue&type=template&id=470eb937&scoped=true&"
import script from "./ExchangeReceivableNoteModel.vue?vue&type=script&lang=js&"
export * from "./ExchangeReceivableNoteModel.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeReceivableNoteModel.vue?vue&type=style&index=0&id=470eb937&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470eb937",
  null
  
)

export default component.exports